import axios from 'axios';
import React, { useEffect, useState } from 'react';

const FirmHeaderImg = ({ firmId, quotNm }) => {

    const imgUrl = process.env.REACT_APP_IMAGE_URL;
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [firmUrl, setFirmUrl] = useState('');

    useEffect(() => {
        if (quotNm) {
            fetchQuotImages(quotNm);
        } else {
            fetchData(firmId);
        }
    }, [firmId, quotNm]);

    const fetchData = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getFirmHeaderImg&firmId=${id}`);
            const url = response?.data?.data?.firmImg;

            const update_url = url?.replace(/ /g, '%20');

            setFirmUrl(update_url);
        } catch (error) {
            console.error('Error during GET request:', error);
            setFirmUrl('');
        }
    };

    const fetchQuotImages = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getQuotationImagesHeader&quotNm=${id}`);
            const url = response?.data?.data?.imgurl;

            const update_url = url?.replace(/ /g, '%20');

            setFirmUrl(update_url);
        } catch (error) {
            console.error('Error during GET request:', error);
            setFirmUrl('');
        }
    };
    // console.log(`${imgUrl}/${firmUrl}`);
    return (
        <>
            {firmUrl !== undefined && <img src={`${imgUrl}/${firmUrl}`} alt="error" style={{ margin: '0 2%', width: '95%' }} />}
        </>
    );
}

export default React.memo(FirmHeaderImg);
